module.exports = __webpack_public_path__ + "static/img/video.62dea21b.jpg";